import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Img from '@src/components/Img';
import UILink from '@src/components/UILink';
import IconLoading from '@src/components/IconLoading';
import AvatarRoundComp from '@src/components/AvatarRound';
import { ButtonGreenPhone as Button } from '@src/components/Button';
import {
	IconArrLeftBig as IconArrLeft,
	IconArrRightBig as IconArrRight,
	IconPlay,
	IconResize,
	IconShare,
} from '@src/components/Icon';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const MediaPreview = (props) => {
	useStyles(css);
	const {
		avatarProps,
		isLoading,
		media,
		contactsLabel = t('Показать контакты'),
		onClickPlay,
		onClickPrev,
		onClickNext,
		onClickResize,
		onClickShare,
		onClickContacts,
		AvatarRound,
		imgTail,
	} = props;

	return (
		<>
			<div className={css.item}>
				{AvatarRound && (
					<AvatarRound
						size={48}
						mods={cn('-size48 -border-outside', css.avt)}
						modsNameLink={css.avtNameLink}
						{...avatarProps}
					/>
				)}
				{onClickContacts && (
					<Button
						size="small"
						label={contactsLabel}
						onClick={onClickContacts}
					/>
				)}
			</div>

			<div className={css.media}>
				{isLoading && <IconLoading size="big" color="grey" />}
				{media && (
					<Img
						pictureClassName={css.mediaPicture}
						imgClassName={css.mediaImg}
						{...media}
						tail={imgTail}
					/>
				)}
				{onClickPlay && (
					<div
						className={cn(css.iconRound, css.iconPlay)}
						tabIndex={0}
						role="button"
						onClick={onClickPlay}
					>
						<IconPlay />
					</div>
				)}
				<div
					className={cn(css.manage, css.iconArrLeft)}
					style={{
						visibility: onClickPrev ? 'visible' : 'hidden',
					}}
					onClick={onClickPrev}
					tabIndex={0}
					role="button"
				>
					<div className={css.iconRound}>
						<IconArrLeft />
					</div>
				</div>

				<div
					className={cn(css.manage, css.iconArrRight)}
					style={{
						visibility: onClickNext ? 'visible' : 'hidden',
					}}
					onClick={onClickNext}
					tabIndex={0}
					role="button"
				>
					<div className={css.iconRound}>
						<IconArrRight />
					</div>
				</div>
			</div>

			{(onClickShare || onClickResize) && (
				<div className={css.item}>
					{onClickResize && (
						<UILink Icon={IconResize} onClick={onClickResize} />
					)}
					{onClickShare && (
						<UILink
							Icon={IconShare}
							label={t('Поделиться')}
							onClick={onClickShare}
						/>
					)}
				</div>
			)}
		</>
	);
};

MediaPreview.propTypes = {
	avatarProps: PropTypes.shape({ ...AvatarRoundComp.type.propTypes }),
	isLoading: PropTypes.bool,
	media: PropTypes.shape({ ...Img.type.propTypes }),
	contactsLabel: PropTypes.string,
	imgTail: PropTypes.string,
	AvatarRound: PropTypes.elementType,
	ShareBtn: PropTypes.elementType,
	onClickPrev: PropTypes.func,
	onClickNext: PropTypes.func,
	onClickPlay: PropTypes.func,
	onClickResize: PropTypes.func,
	onClickShare: PropTypes.func,
	onClickContacts: PropTypes.func,
};

MediaPreview.defaultProps = {
	avatarProps: undefined,
	isLoading: false,
	media: undefined,
	AvatarRound: AvatarRoundComp,
	ShareBtn: undefined,
	onClickPrev: undefined,
	onClickNext: undefined,
	onClickPlay: undefined,
	onClickResize: undefined,
	onClickShare: undefined,
	onClickContacts: undefined,
	imgTail: '=w1500-h1000-l95-e31',
	contactsLabel: undefined,
};

export default MediaPreview;
